import { RefString, RefBool, HashRef } from '@tblabs/truffle';
import { Translations } from '../Translations/Translations';
import { AppConfigProvider } from '../Services/AppConfigProvider';
import { PasswordSanitizer } from '../Services/PasswordSanitizer';
import { IAuth } from '../Services/Auth/IAuth';


export class LoginLogic
{
    public PasswordInput = new RefString().Storable("password-input");
    public ErrorMessageVisible = new RefBool();
    public ErrorMessage = new RefString();

    constructor(private _auth: IAuth, private _hash: HashRef, private _lang: Translations, private _config: AppConfigProvider)
    {
        this.PasswordInput.value ??= this._config.Password;

        this.PasswordInput.OnChange(() =>
        {
            this.ErrorMessageVisible.False();
        });
    }

    public async TryLogin(): Promise<void>
    {
        const password = PasswordSanitizer.Sanitize(this.PasswordInput.value);

        if (!password)
        {
            this.ShowErrorMessage(this._lang.NoPasswordProvided.value);
            return;
        }

        if (password == "demo")
        {
            this._hash.value = "watch/demo";
            return;
        }

        this.ErrorMessageVisible.False();

        const loginResult = await this._auth.TryLogin(password);

        if (loginResult.IsAuthorized)
        {
            document.title = loginResult.DeviceId || "";
            this._hash.value = "watch/" + this._config.ServerInfo.Id + "/" + password;
        }
        else
        {
            this.ShowErrorMessage(loginResult.Message);
        }
    }

    private ShowErrorMessage(message: string): void
    {
        this.ErrorMessage.value = message;
        this.ErrorMessageVisible.True();
    }
}
